import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/copybook',
  component: Layout,
  name: 'Copybook',
  meta: {
    title: '字帖',
    icon: 'i-ant-design:edit-twotone',
    order: 3,
  },
  children: [
    {
      path: '',
      name: 'CopybookList',
      component: () => import('@/views/copybook/index.vue'),
      meta: {
        title: '字帖管理',
        icon: 'i-ant-design:file-text-twotone',
        auth: 'copybook:list',
        menu: false,
      },
    },
  ],
}

export default routes
